'use client';

import React from 'react';

interface TextInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
}

export const TextInput: React.FC<TextInputProps> = ({
  prefix,
  suffix,
  className = '',
  ...props
}) => {
  return (
    <div className="relative">
      {prefix && (
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 flex items-center">
          {prefix}
        </div>
      )}
      <input
        {...props}
        className={`w-full ${
          prefix ? 'pl-9' : 'pl-3'
        } ${suffix ? 'pr-9' : 'pr-3'} py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
      />
      {suffix && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 flex items-center">
          {suffix}
        </div>
      )}
    </div>
  );
};

